import queryString from "query-string";
import { useMemo } from "react";
import { useParams, useHistory, useRouteMatch } from "react-router-dom";

import { Routes } from "constants/routes";

export interface IUseClientParamsHooks {
  clientId: number;
  folderId: number | null;
  fileId: number | null;
  sectionId: number | null;
}

export function useClientParamsHooks(): IUseClientParamsHooks {
  const { location } = useHistory();
  const routeParams: Record<string, string | undefined> = useParams();

  // useRouteMatch extracts params from sub-route patterns that useParams() misses
  // because the router only defines <Route path={Routes.clientWorkspace}> without :folder_id
  const folderMatch = useRouteMatch<{ client_id: string; folder_id: string }>(Routes.clientWorkspaceFolder);
  const fileMatch = useRouteMatch<{ client_id: string; file_id: string }>(Routes.clientWorkspaceFile);

  const queryParams = useMemo(() => {
    return queryString.parse(location.search);
  }, [location.search]);

  const clientId = useMemo(() => Number(routeParams.client_id), [routeParams]);
  const folderId = useMemo(() => {
    const raw = folderMatch?.params.folder_id ?? routeParams.folder_id;
    const id = Number(raw);
    return Number.isNaN(id) ? null : id;
  }, [folderMatch, routeParams]);
  const fileId = useMemo(() => {
    const raw = fileMatch?.params.file_id ?? routeParams.file_id;
    const id = Number(raw);
    return Number.isNaN(id) ? null : id;
  }, [fileMatch, routeParams]);
  const sectionId = useMemo(() => {
    const id = Number(queryParams.section);
    return Number.isNaN(id) ? null : id;
  }, [queryParams.section]);

  return { clientId, folderId, fileId, sectionId };
}
